module.exports = {"620201100":"新城镇","620201101":"峪泉镇","620201102":"文殊镇","620201401":"雄关区","620201402":"镜铁区","620201403":"长城区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620201.json
// module id = 2899
// module chunks = 0